import { createContext, useContext } from "react";

import { type PageTarget } from "./page_tag";

// Opens a cited page beside the chat, as a page tag does; null outside the
// assistant's pane, where a citation stays as written.
export const OpenPageContext = createContext<
  ((target: PageTarget) => void) | null
>(null);

export const useOpenPage = () => useContext(OpenPageContext);
